(function () {
    "use strict";

    angular
        .module("app")
        .directive("intOnly", d);

    function d() {
        const MAX_SIGNED_INT = 2147483647;
        return {
            require: "ngModel",
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }

                ngModelCtrl.$parsers.push(function (val) {
                    // return value is what ng-model is set to
                    if (angular.isUndefined(val)) {
                        val = "";
                    }

                    let clean = val.toString().replace(/[^0-9]/g, "");

                    if (val.length && val.startsWith("-") && attrs["allowNegative"])
                        clean = "-" + clean;

                    if (clean === "-") {
                        if (val !== "-") {
                            ngModelCtrl.$setViewValue(clean); // leave "-" in the view
                            ngModelCtrl.$render();
                        }
                        return ""; // no value for ng-model
                    }

                    clean = parseInt(clean);
                    if (isNaN(clean))
                        clean = "";
                    else if (clean > MAX_SIGNED_INT)
                        clean = ngModelCtrl.$modelValue; // use previous good value

                    if (val !== clean.toString()) {
                        ngModelCtrl.$setViewValue(clean);
                        ngModelCtrl.$render();
                    }

                    return clean;
                });

                element.bind("keypress", function (event) {
                    if (event.keyCode === 32) {
                        event.preventDefault();
                    }
                });
            }
        };
    }
    d.$inject = [];

})()